import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class Benefits {
	constructor(el) {
		this.el = el
		this.list = el.querySelector('.benefits__list')
		this.items = el.querySelectorAll('.benefits__item')
		this.media = el.querySelector('.benefits__image-holder')
		this.images = el.querySelectorAll('.benefits__image.desktop')

		if (window.innerWidth > 650) {
			this.pinMedia()
			this.animateRows()
		}
	}
	pinMedia() {
		const tl = gsap.timeline({
			scrollTrigger: {
				pin: true,
				pinSpacing: false,
				trigger: this.media,
				endTrigger: this.list,
				start: 'top top+=24',
				end: 'bottom bottom+=24',
				// markers: true,
			} 
		})
	}
	animateRows() {
		this.items.forEach((item, i) => {

			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: item,
					start: 'top 80%',
					end: 'bottom 20%',
					toggleClass: 'active',
					scrub: 0.75,
					onEnter: () => {
						this.changeImage(i)
					},
					onEnterBack: () => {
						this.changeImage(i)
					}
				}
			})
		})
	}

	changeImage(index) {
		this.images.forEach(image => image.classList.remove('active'))
		this.images[index].classList.add('active')
	}
}

export const initBenefits = () => {
	document.querySelectorAll('.benefits').forEach(el => {
		new Benefits(el)
	})
}

export default () => {}